import { Component, inject, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { CarCommandsService } from '../../../../../services/vehicles/car-commands-service';
import { Card } from 'primeng/card';

@Component({
  selector: 'app-car-details-commands-component',
  imports: [DialogModule, ButtonModule, Card],
  templateUrl: './car-details-commands-component.html',
  styleUrl: './car-details-commands-component.scss',
})
export class CarDetailsCommandsComponent {

  @Input() carID: string;

  actions = [
    {
      label: 'Lock door',
      description: 'Engage central locking all doors.',
      icon: 'lock-door.svg',
      iconBg: '#EEF2FF',
      iconColor: '#4f7cdc',
      critical: false,
      api: () => this.lockDoor(),
    },
    {
      label: 'Unlock door',
      description: 'Release central locking. Engine remains immobilized.',
      icon: 'unlock-door.svg',
      iconBg: '#ECFDF5',
      iconColor: '#10b981',
      critical: false,
      api: () => this.unlockDoor(),
    },
    {
      label: 'Disable engine',
      description: 'Immediately cut engine on next stop.',
      icon: 'disable-engine.svg',
      iconBg: '#FFF1F2',
      iconColor: '#e05c5c',
      critical: true,
      api: () => this.disableEngine(),
    },
    {
      label: 'Enable engine',
      description: 'Re-authorize engine ignition on next start.',
      icon: 'enable-engine.svg',
      iconBg: '#ECFDF5',
      iconColor: '#10b981',
      critical: false,
      api: () => this.enableEngine(),
    },
    {
      label: 'Disable Engine & Lock door',
      description: 'Engage central locking all doors.',
      icon: 'battery-disable.svg',
      iconBg: '#FFF1F2',
      iconColor: '#e05c5c',
      critical: true,
      api: () => this.disableEngineLockDoor(),
    },
    {
      label: 'Enable Engine & Unlock door',
      description: 'Release central locking. Engine remains immobilized.',
      icon: 'unlock-door.svg',
      iconBg: '#ECFDF5',
      iconColor: '#10b981',
      critical: false,
      api: () => this.enableEngineUnlockDoor(),
    },
    {
      label: 'Update Vehicle',
      description: 'Pulls an immediate inventory put.',
      icon: 'update.svg',
      iconBg: '#EEF2FF',
      iconColor: '#4f7cdc',
      critical: false,
      api: () => this.updateCarTelemetry(),
    },
  ];

  selectedAction: (typeof this.actions)[number] | null = null;
  confirmVisible = false;

  private carCommandsService = inject(CarCommandsService);

  onAction(action: (typeof this.actions)[number]) {
    this.selectedAction = action;
    this.confirmVisible = true;
  }

  runAction() {
    this.selectedAction?.api();
    this.confirmVisible = false;
    this.selectedAction = null;
  }

  cancelAction() {
    this.confirmVisible = false;
    this.selectedAction = null;
  }


  lockDoor = () => {
    this.carCommandsService.lockDoor(this.carID).subscribe()
  }

  unlockDoor = () => {
    this.carCommandsService.unlockDoor(this.carID).subscribe()
  }

  enableEngine = () => {
    this.carCommandsService.enableEngine(this.carID).subscribe()
  }

  disableEngine = () => {
    this.carCommandsService.disableEngine(this.carID).subscribe()
  }

  enableEngineUnlockDoor = () => {
    this.carCommandsService.enableEngineAndUnlockDoor(this.carID).subscribe()
  }

  disableEngineLockDoor = () => {
    this.carCommandsService.disableEngineAndLockDoor(this.carID).subscribe()
  }
  updateCarTelemetry = () => {
    this.carCommandsService.updateCarTelemetry(this.carID).subscribe()
  }

}
